import { VisitFinishApprovedCommand } from '@dreryk/egabinet-visit-frontend-api';

import { ActionEventInterceptor, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { visitDetailsTranslationKeys, visitTranslationKeys } from '../../../../../translations';
import { VisitFormController } from '../../../visitForm.types';
import { useVisitCommand } from '../../shared/confirmVisit.hooks';

type VisitSummaryConfirmActionEventInterceptorProps = Pick<VisitFormController, 'handleSubmit'> &
   Readonly<{
      children: JSX.Element;
      visitId: number;
   }>;

export const VisitSummaryConfirmActionEventInterceptor = (
   props: VisitSummaryConfirmActionEventInterceptorProps
): JSX.Element => {
   const { executeAsync: executeVisitCommand } = useVisitCommand(VisitFinishApprovedCommand, {
      visitId: props.visitId,
      onSuccess: () => {
         dispatchSnackbarPositiveEvent(visitDetailsTranslationKeys.visitConfirmed);
      },
   });

   return (
      <ActionEventInterceptor
         action={props.handleSubmit(executeVisitCommand)}
         blockingOperation={visitTranslationKeys.confirmingVisit}
      >
         {props.children}
      </ActionEventInterceptor>
   );
};
